'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Config for project. Use `app` to configure the app */

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  devApiHost: process.env.DEVAPIHOST || 'localhost',
  devApiPort: process.env.DEVAPIPORT || 8081,
  apiHost: process.env.APIHOST || 'cright.com',
  apiPort: process.env.APIPORT || 443,
  apiProtocol: process.env.APIPROTOCOL || 'https',
  apiRoot: '/webapi/api',
  useApiProxy: true,
  response: {
    dataField: 'data',
    statusField: 'code',
    messageField: 'msg'
  },
  app: {
    title: 'CRight Web App',
    description: 'CRight Web App.',
    head: {
      titleTemplate: 'CRight Web App: %s',
      meta: [{ name: 'description', content: 'CRight Web App.' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'CRight' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'CRight' }, { property: 'og:description', content: 'CRight Web App.' }, { property: 'og:card', content: 'summary' }, { property: 'og:site', content: '@citronium' }, { property: 'og:creator', content: '@citronium' }, { property: 'og:image:width', content: '200' }, { property: 'og:image:height', content: '200' }]
    },
    mainColor: '#0f73ed',
    urlParts: {
      thumb: 'https://111-eu-cright-images-depot.s3.amazonaws.com/thumb_',
      press: 'https://www.cright.com/webapi/fileExchange/',
      audio: 'https://cright.com/cright/bo/files/zipwav/',
      audioArchive: 'https://cright.com/cright/bo/files/bizip/',
      label: 'https://cright.com/cright/Content/logo/',
      download: 'https://cright.com/cright/loginViewerwip/dwnsa/',
      report: 'https://cright.com/webapi/fileExchange/'
    },
    srcMasks: {
      audio: 'https://111-eu-cright-audiostream.s3.amazonaws.com/<trackName>.mp3',
      video: 'http://wsvideo.cright.com/<trackName>.mp4'
    },
    langs: [{ code: 'en', name: 'English', abbr: 'ENG' }, { code: 'fr', name: 'Français', abbr: 'FR' }, { code: 'de', name: 'Deutsch', abbr: 'DE' }, { code: 'es', name: 'Español', abbr: 'ESP' }, { code: 'it', name: 'Italiano', abbr: 'IT' }, { code: 'pt', name: 'Portugues', abbr: 'PT' }, { code: 'ja', name: '日本語', abbr: 'JAP' }, { code: 'zh-CN', name: '中國', abbr: 'CN' }],
    uploaderSupportedFormats: {
      audio: ['mp3', 'aiff', 'wav', 'm4a', 'ogg'],
      video: ['mp4', 'wmv', 'mov', 'avi'],
      press: ['pdf', 'zip', 'jpg', 'png', 'tiff', 'xls', 'doc', 'docx'],
      cover: ['jpg', 'jpeg', 'png', 'bmp']
    },
    audioPrecacheBeforeTime: 10, // seconds to song end, when the next track caching is starting
    storeUrls: {
      ios: 'https://itunes.apple.com/ru/app/cright/id905744164',
      android: 'https://play.google.com/store/apps/details?id=com.cright.mobile'
    },
    dropbox: {
      appKey: 'cgvkohm0zfq09au',
      fileFields: { link: 'link', name: 'name' },
      serviceName: 'dropbox'
    },
    boxcom: {
      clientId: '6e6bqhb028n581povng5bsum2dkbkwvp',
      fileFields: { link: 'url', name: 'name' },
      serviceName: 'boxcom'
    },
    defaultUserRoute: '/playlists/all',
    defaultRedirectRoute: '/',
    ga: {
      devKey: 'UA-91317123-1'
    },
    googleMaps: {
      apiKey: 'AIzaSyDqgEcCRYfJ0vuDD8rnMCIwdc_Rvw9W84o'
    },
    productionUrl: 'https://web.cright.com'
  }
}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 41
// module chunks = 1